export interface IFareSelectorsBoolean {
  customerType: boolean;
  zone: boolean;
  travelMethod: boolean;
  travelTime: boolean;
}

export const initialFareSelectorState: IFareSelectorsBoolean = {
  customerType: false,
  zone: false,
  travelMethod: false,
  travelTime: false,
};
